<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before:always;"></div>
<p class="P_Normal__And__Page_Break" id="auto_bookmark_table_of_contents_1">Thank you to Dreamspinner Press and all the wonderful folks who believe in me, guide me, inspire, and support.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0002.vue?f84f8624